<template>
  <div class="content-wrapper">
    <ContentHeader title="Профиль" />
    <div class="content-body">
      <card headerTitle="КОНТАКТЫ" :busy="isProfileLoading" @reload="reloadProfile">
        <template slot="block">
          <form
            id="contacts_from"
            class="form-horizontal form-simple"
            @submit.prevent="updateUser"
          >
            <div v-if="showContactsError" class="alert alert-danger" role="alert">
              <span>{{contactsError}}</span>
              <a class="float-xs-right" @click="showContactsError = false">X</a>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="profileNameInput">
                    <template v-if="getProfile.type===0">Контактное лицо, Ф.И.О.:</template>
                    <template v-else>Наименование компании:</template>
                  </label>
                  <input
                    type="text"
                    id="profileNameInput"
                    class="form-control"
                    placeholder="Василий Петрович Иванов"
                    :value="getProfile.name"
                    disabled
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="innInput">
                    <template v-if="getProfile.type===0">ИНН:</template>
                    <template v-else>БИН:</template>
                  </label>
                  <input
                    type="inn"
                    id="innInput"
                    class="form-control"
                    placeholder="inn"
                    :value="getProfile.inn"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="emailInput">E-mail:</label>
                  <input
                    type="email"
                    id="emailInput"
                    class="form-control"
                    placeholder="email@example.com"
                    name="email"
                    :value="getProfileEmail"
                    @input="resetUpdateButton"
                    required
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="mobileInput">Сотовый телефон:</label>
                  <input
                    type="tel"
                    id="mobileInput"
                    class="form-control"
                    placeholder="8 800 555 35 35"
                    name="mobile"
                    :value="getProfileMobile"
                    @input="resetUpdateButton"
                    required
                    pattern="^[+]?[0-9]{11}"
                    title="11 цифр без пробелов, с «+» в начале или без"
                  />
                </div>
              </div>
            </div>
          </form>
        </template>
        <template slot="footer">
          <button type="submit" form="contacts_from" class="btn btn-success btn-min-width">
            <i
              :class="{'icon-save':!isProfileUpdateLoading&&!isProfileUpdateSucceed, 'icon-ei-spinner-3 spin':isProfileUpdateLoading, 'icon-check2':isProfileUpdateSucceed}"
            ></i> Сохранить
          </button>
        </template>
      </card>
      <card headerTitle="АВТОРИЗАЦИЯ" :busy="isProfileLoading" @reload="reloadProfile">
        <template slot="block">
          <form id="authEditForm" @submit.prevent="changePass">
            <div style="padding-bottom: 20px;">
              <p class="bg-prim-grey" style="padding: 10px;">
                Логин:
                <strong>{{getProfile.login}}</strong>
              </p>
            </div>
            <h4 class="form-section">Изменение пароля</h4>
            <div v-if="showChangePassError" class="alert alert-danger" role="alert">
              <span>{{passError}}</span>
              <a class="float-xs-right" @click="showChangePassError = false">X</a>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="projectinput35">Старый пароль</label>
                  <input
                    type="password"
                    id="projectinput35"
                    class="form-control"
                    placeholder="**************"
                    name="old_password"
                    v-model="old_password"
                    @input="resetChangePassButton"
                    required
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="projectinput45">Новый пароль</label>
                  <input
                    type="password"
                    id="projectinput45"
                    class="form-control"
                    placeholder="**************"
                    name="password"
                    v-model="password"
                    @input="resetChangePassButton"
                    required
                  />
                </div>
              </div>
            </div>
          </form>
        </template>
        <template slot="footer">
          <button
            type="submit"
            form="authEditForm"
            class="btn btn-success btn-min-width"
          >
            <i
              :class="{'icon-save':!isChangePassLoading&&!isChangePassSucceed, 'icon-ei-spinner-3 spin':isChangePassLoading, 'icon-check2':isChangePassSucceed}"
            ></i> Сохранить
          </button>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader.vue";
import card from "@/components/card.vue";
import { mapGetters } from "vuex";
import {
  USER_REQUEST,
  USER_UPDATE_REQUEST,
  USER_UPDATE_RESET,
  USER_CHANGE_PASS_REQUEST,
  USER_CHANGE_PASS_RESET,
} from "@/store/actions/user";

export default {
  name: "Profile",
  components: {
    ContentHeader,
    card,
  },
  data() {
    return {
      old_password: null,
      password: null,
      showContactsError: false,
      contactsError: "Неверный формат E-mail!",
      showChangePassError: false,
      passError: "Старый пароль введён неверно!",
    };
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "getProfileDetails",
      "getProfileEmail",
      "getProfileMobile",
      "isProfileLoading",
      "profileOnceLoaded",
      "isProfileUpdateLoading",
      "isProfileUpdateSucceed",
      "isChangePassLoading",
      "isChangePassSucceed",
    ]),
  },
  methods: {
    updateUser() {
      this.showContactsError = false;

      const emailRegular = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
      const email = document.getElementById("emailInput").value;
      const mobile = document.getElementById("mobileInput").value;
      if (!emailRegular.test(email)) {
        this.showContactsError = true;
        return;
      }

      let body = JSON.stringify({
        email,
        mobile,
      });
      this.$store.dispatch(USER_UPDATE_REQUEST, { body });
    },
    changePass() {
      this.showChangePassError = false;
      this.$store
        .dispatch(USER_CHANGE_PASS_REQUEST, {
          old_password: this.old_password,
          password: this.password,
        })
        .then()
        .catch((err) => {
          if (err.response.data.error === "unknown user") {
            this.passError = "Старый пароль введён неверно!";
          } else if (err.response.data.error === "password not correct") {
            this.passError = "Пароль должен быть от 6 до 100 символов!";
          } else {
            this.passError = "Ошибка сервера! Попробуйте позже";
          }
          this.showChangePassError = true;
        });
    },
    resetUpdateButton() {
      this.$store.commit(USER_UPDATE_RESET);
    },
    resetChangePassButton() {
      this.$store.commit(USER_CHANGE_PASS_RESET);
    },
    reloadProfile(){
      this.$store.dispatch(USER_REQUEST).then();
    },
  },
  created() {
    if (!this.profileOnceLoaded) this.$store.dispatch(USER_REQUEST).then();
  },
  beforeMount() {},
  beforeDestroy() {
    this.$store.commit(USER_UPDATE_RESET);
    this.$store.commit(USER_CHANGE_PASS_RESET);
  },
};
</script>